import Svg, { Defs, G, Path, RadialGradient, Stop } from 'react-native-svg';
import { useId } from 'react';
import { withDefaultIconProps } from './index';

export const SuperSharerMedal = withDefaultIconProps(
  {
    height: 69,
    width: 57,
  },
  ({ color: _color, style, ...rest }) => {
    const id = useId();
    const gradientId = `${id}-paint0_radial`;
    return (
      <Svg {...rest} viewBox="0 0 57 69" style={style}>
        <G>
          <G>
            <Path
              d="M17.473 30.781h21.484v22.774c0 1.294-1.504 2.007-2.506 1.188l-7.265-5.938a1.535 1.535 0 00-1.942 0l-7.265 5.938c-1.002.819-2.506.106-2.506-1.188V30.78z"
              fill={`url(#${gradientId})`}
            />
          </G>
          <Path
            opacity={0.13}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.473 43.028V32.494h21.484v10.534a18.33 18.33 0 01-10.742 3.456 18.332 18.332 0 01-10.742-3.456z"
            fill="#315B4A"
          />
          <G>
            <Path
              d="M46.63 24.215c0 10.17-8.245 18.414-18.415 18.414S9.8 34.385 9.8 24.215C9.8 14.045 18.045 5.8 28.215 5.8S46.63 14.044 46.63 24.215z"
              fill="#B4ECDF"
            />
          </G>
          <G>
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.215 41.63c9.618 0 17.415-7.797 17.415-17.415 0-9.618-7.797-17.415-17.415-17.415-9.618 0-17.415 7.797-17.415 17.415 0 9.618 7.797 17.414 17.415 17.414zm0 1c10.17 0 18.415-8.245 18.415-18.415S38.385 5.8 28.215 5.8 9.8 14.044 9.8 24.215c0 10.17 8.245 18.414 18.415 18.414z"
              fill="#fff"
            />
          </G>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.612 14.683l.076.856c.676 7.587-1.714 12.85-5.169 15.737-3.211 2.686-7.343 3.285-10.473 1.668l-1.882 1.902a.857.857 0 01-1.218-1.205l1.834-1.853c-1.94-3.299-1.523-7.199 1.075-10.418 2.71-3.358 7.746-5.947 14.901-6.608l.856-.079zM23.328 31.65l8.885-8.98a.857.857 0 00-1.217-1.205l-8.959 9.053c-1.291-2.541-.932-5.49 1.151-8.071 2.233-2.767 6.489-5.134 12.858-5.887.387 6.665-1.81 11.05-4.625 13.403-2.596 2.17-5.72 2.646-8.093 1.687z"
            fill="#2B8176"
          />
        </G>
        <Defs>
          <RadialGradient
            id={gradientId}
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(94.686 -2.062 31.37) scale(12.6057 18.5619)"
          >
            <Stop stopColor="#315B4A" />
            <Stop offset={1} stopColor="#64BAAF" />
          </RadialGradient>
        </Defs>
      </Svg>
    );
  },
);
